import { Search, Container, Menu } from "lucide-react";
import NotificationBell from "@/components/NotificationBell";
import PingBell from "@/components/PingBell";
import { useAuth } from "@/context/AuthContext";

export default function TopBar({ onToggleSidebar }) {
  const { user } = useAuth();
  return (
    <header className="topbar" data-testid="topbar">
      <button
        onClick={onToggleSidebar}
        className="topbar-hamburger"
        aria-label="Toggle menu"
        data-testid="sidebar-toggle"
      >
        <Menu className="w-5 h-5" />
      </button>
      <div className="flex items-center gap-2 min-w-0 md:min-w-[220px] pl-1">
        <div className="w-7 h-7 rounded-md bg-white/15 flex items-center justify-center flex-shrink-0">
          <Container className="w-4 h-4 text-white" strokeWidth={2.2} />
        </div>
        <div className="leading-tight min-w-0">
          <p className="text-[13px] font-semibold tracking-tight">CERF</p>
          <p className="text-[10px] uppercase tracking-widest text-white/70 -mt-0.5">LeadFlow</p>
        </div>
      </div>

      <div className="flex-1 justify-center px-4 hidden md:flex">
        <div className="relative w-full max-w-[480px]">
          <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-white/70" />
          <input
            className="topbar-search"
            placeholder="Search leads, members…"
            data-testid="topbar-search"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                const q = e.target.value.trim();
                if (q) window.location.href = `/dashboard/leads?q=${encodeURIComponent(q)}`;
              }
            }}
          />
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-3 md:min-w-[220px] justify-end ml-auto">
        <PingBell />
        <NotificationBell />
        <div className="topbar-user-wrap flex items-center gap-2" data-testid="topbar-user">
          <div
            className="relative w-7 h-7 rounded-full bg-white/15 border border-white/25 flex items-center justify-center text-[11px] font-semibold text-white cursor-default select-none"
            aria-label={user?.name}
            data-testid="topbar-user-avatar"
          >
            {(user?.name || "?").split(" ").map(x => x[0]).slice(0, 2).join("")}
            <span className="topbar-user-tooltip" role="tooltip">
              <span className="block font-medium text-slate-900">{user?.name}</span>
              <span className="block text-[10px] uppercase tracking-widest text-slate-500 mt-0.5">{user?.role}</span>
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
